import FrameComponent from "@/App/Main/Frame/index.vue";
import { Frame, store } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    Frame: FrameComponent,
  },
})
export default class FrameWindow extends Vue {
  @Prop({ required: true })
  frame!: Frame

  mounted() {
    this.resize()
    this.raiseWindowWhenSelected()
    this.syncWcs()
  }

  private syncWcs() {
    this.$watch(() => this.frame.view, (view) => {
      if (store.config.frame.lock.wcs) {
        for (const f of store.frames) {
          if (f !== this.frame) {
            Object.assign(f.view, view)
          }
        }
      }
    })
  }

  private raiseWindowWhenSelected() {
    this.$watch(() => store.currentFrameIndex, (i) => {
      this.frameIndex === i && (this.$refs.window as any).activate()
    })
  }

  resize() {
    const globe = store.globe(this.frame)
    globe.resize()
  }

  activate() {
    store.currentFrameIndex = this.frameIndex
  }

  get frameIndex() {
    return store.frames.indexOf(this.frame)
  }

  get current() {
    return store.currentFrameIndex === this.frameIndex
  }

  rename() {
    const newName = prompt(`Frame name?`, this.frame.name)
    if (newName) {
      this.frame.name = newName
    }
  }

  closeRequest() {
    if (confirm(`Are you sure to delete frame "${this.frame.name}"?`)) {
      store.currentFrameIndex = 0
      store.frames.splice(this.frameIndex, 1)
    }
  }
}
